import React from "react";
import { useState } from "react";
import { Trans } from "react-i18next";

const DEFAULT_DATA = {
  profileImage: "img/ford-personel-bahadir-akin.jpg",
  fullname: "Bahadır Akın",
  title: "Bayi Eğitim Yöneticisi",
  mail: "bakin@ford.com.tr",
  phone: "+902165647250",
  formattedPhone: "+90 216 564 72 50",
  responsibilities: [
    "Şirket hedeflerine ulaşmak için gereken eğitim departmanının sorumluluğundaki stratejileri planlamak.",
    "Bu stratejileri gerçekleştirmek için gerekli bölüm oganizasyonunu oluşturmak.",
  ],
};

const OrganizationCard = ({ employee = DEFAULT_DATA }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      className={`col-xs-12 col-sm-12 col-md-6 col-lg-4 fordOrgCard ${isOpen ? "open DivFullOpen" : "DivFullClose"
        }`}
    >
      <div className="fordOrgCardInner">
        <div className="fordOrgCardProfilImgArea">
          <div
            className="fordOrgCardProfilImg"
            style={{
              backgroundImage: `url('${employee.profileImage}')`,
            }}
          ></div>
        </div>
        <div className="fordOrgCardProfilTextArea">
          <div className="fordOrgCardName">{employee?.fullname}</div>
          <div className="fordOrgCardTitle">{employee?.title}</div>
        </div>
        <div className="fordOrgCardDesc my-2 p-2">
          <div className="descTitle">
            <Trans>duties_and_responsibilities</Trans>
          </div>
          <div className="descText">
            <ul>
              {employee?.responsibilities?.map((responsibility, index) => {
                return <li key={index}>{responsibility}</li>;
              })}
            </ul>
          </div>
        </div>
        <div className="fordOrgCardBottom py-2">
          <ul className="fordOrgCardBottomLinks">
            <li>
              <a href={`mailto:${employee.mail}`}>
                <span className="iconmford fo-icon-contact-mail"></span>
              </a>
            </li>
            <li>
              <a href={`tel:${employee.phone}`}>
                <span className="iconmford fo-icon-phone"></span> |{" "}
                {employee?.formattedPhone}
              </a>
            </li>
          </ul>
        </div>
        <div className="fordOrgCardDownMenu">
          <a onClick={() => setIsOpen(!isOpen)}>
            <span className="iconmford fo-icon-expand-more"></span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default OrganizationCard;
